//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    features: {
      type: Array,
      required: true,
    }
  },
  computed: {
    prices () {
      return [...this.item.prices].sort((a, b) => b.monthly_price - a.monthly_price)
    },
    itemFeatures () {
      return this.features.reduce((acc, cur) => {
        const itemFeature = this.item.data.features.find(f => f.id === cur.id)
        if (itemFeature) {
          return [...acc, { ...cur, ...itemFeature }]
        }

        return acc
      }, [])
    },
    promotedFeatures () {
      return this.item.data.promoted_features
        .map((feat) => {
          if (typeof feat === 'string') {
            return this.itemFeatures.find(({ id }) => id === feat)
          }

          return feat
        })
        .filter(f => !!f && f.id !== 'monitor')
    }
  },
}
